import React from "react";
import { Text, StyleSheet, View, BackHandler, Linking } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Screen, Button, ButtonVariant } from "../../components";
import { MaintenancePolling } from "../../utils/maintenance";
import { translate } from "../../i18n";


const supportUrl = 'https://domusoinc.zendesk.com/hc/en-us';


export const MaintenanceStack = () => {
    const navigation = useNavigation();
    MaintenancePolling.stop();
    return (
        <Screen style={style.container}>
            <View style={{flex:.5, paddingTop: 20, alignSelf: 'flex-end'}}>
                <Button
                    icon={require('../../../assets/support.png')}
                    borderRadius={50}
                    contentStyle={{
                        height: 44
                    }}
                    style={style.supportButton}
                    textStyle={{...style.commonText, ...style.supportButtonText}}
                    mode="contained"
                    variant={ButtonVariant.LIGHT}
                    onPress={async () => {
                        if (await Linking.canOpenURL(supportUrl)) {
                            await Linking.openURL(supportUrl)
                        }
                    }}>
                    <Text
                        style={{...style.commonText, ...style.supportButtonText}}
                    >
                        {translate("maintenance.support")}
                    </Text>
                </Button>
            </View>
            <View style={{flex:6, alignItems: 'center', justifyContent: 'center'}}>
                <Text style={{...style.commonText, ...style.title}}>
                    {translate("maintenance.systemdown")}
                </Text>
                <Text style={{...style.commonText, ...style.message}}>
                    {translate("maintenance.difficulty")}
                </Text>
                <Text style={{...style.commonText, ...style.later}}>
                    {translate("maintenance.checkback")}
                </Text>
                <Button
                    icon="refresh"
                    iconColor="white"
                    iconSize={40}
                    tx="maintenance.tryagain"
                    mode="contained"
                    style={style.okButton}
                    textStyle={{...style.commonText, ...style.okButtonText}}
                    onPress={() => MaintenancePolling.retry()}
                />
            </View>
        </Screen>
    );
}

const style = StyleSheet.create({
    supportButton: {
        borderColor: '#0B1336',
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        width: '30%'
    },
    supportButtonText: {
        color: '#0B1336',
    },
    okButton: {
        backgroundColor: '#F26924',
        borderRadius: 50,
        width: '50%',
        marginTop: 40
    },
    okButtonText: {
        color: '#fff',
        fontSize: 20,
        lineHeight: 30
    },
    commonText: {
        color: '#666666',
        fontFamily: 'Lato',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 24,
        textAlign: 'center',
    },
    container: {
        backgroundColor: '#fff',
        flex: 1,
        justifyContent: 'center'
    },
    title: {
        color: '#D81620',
        fontSize: 32,
        fontWeight: '700',
        lineHeight: 48,
        paddingBottom: 8,
    },
    message: {
    },
    later: {
        fontWeight: '700'
    }
});